<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    description?: string
    crumbs?: []
  }>(),
  {
    title: 'Forbidden',
    description: 'You are not authorized to access this page.',
    crumbs: () => []
  }
)

const route = useRoute()
const { t } = useI18n()

const isDashboard = computed(() => {
  return route.name === 'Dashboard'
})
</script>

<template>
  <div class="relative h-screen overflow-hidden rounded-lg">
    <TheListHeader v-if="title" :title="t(title)" />
    <div class="flex h-full flex-col items-center justify-center rounded-lg bg-white p-4 text-center sm:mx-12 sm:mb-12">
      <div class="mb-4 flex justify-center">
        <img class="max-w-[24em]" src="/images/errors/403.png" />
      </div>
      <h2 class="mb-4 text-sm font-bold uppercase sm:text-2xl">
        {{ t('forbidden.title') }}
      </h2>
      <p class="mt-2 tracking-tight text-foreground-secondary">
        {{ t('forbidden.description.access') }}
      </p>
      <p class="tracking-tight text-foreground-secondary">
        {{ t('forbidden.description.contact') }}
      </p>
      <div class="mb-7 mt-4 pt-2">
        <router-link
          v-if="!isDashboard"
          :to="{ name: 'Dashboard' }"
          class="fixed bottom-0 left-0 z-10 inline-flex w-screen items-center justify-center border border-transparent bg-primary px-4 py-5 text-sm font-medium leading-4 text-white hover:bg-primary/90 focus:outline-hidden focus:ring-2 focus:ring-primary focus:ring-offset-2 sm:static sm:w-auto sm:rounded-md sm:py-2"
        >
          {{ t('forbidden.back') }}
        </router-link>
      </div>
    </div>
  </div>
</template>
